// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/vfr-ott-minima.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/vfr-ott-minima/vfr-ott-clearance.js';
import g1 from '../lessons/air-law/vfr-ott-minima/vfr-ott-minima.js';

mount([g0, g1]);
